import React from 'react';

function ChevronUpLight({
  size = 32,
  className,
}: {
  size?: number;
  className?: string;
}): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      viewBox="0 0 32 32"
      width={size}
      className={className}
    >
      <path d="M1.176 24.549l-1.176-1.176 16-16 16 16-1.176 1.176-14.824-14.824-14.824 14.824z"></path>
    </svg>
  );
}

export default ChevronUpLight;
